export default __webpack_public_path__ + "static/media/push.0c204cb5.png";